exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7ba5bd90]:export{menu-bgc-oragne:#F2C46D}#app[data-v-7ba5bd90]{font-size:16px}\n", ""]);

// exports
